import { useRef, useMemo } from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  // GenerateCustomerSatisfactionReport,
  GqlTable,
} from "../../components";

import { Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { CustomerSatisfaction } from "../../../graphql/models";

import useCustomerSatisfactionsStyle from "./customer_satisfactions.style";

function CustomerSatisfactionsPage(props: any) {
  const classes = useCustomerSatisfactionsStyle();

  const tableRef = useRef();

  // const gqlTableRowActions = useCallback((row: CustomerSatisfaction) => {
  //   const actions: ReactNode[] = [];

  //   if (isAdminUser) {
  //     actions.push(
  //       <EditButton onClick={() => editCustomerSatisfaction(row)} />
  //     );
  //     actions.push(
  //       <GenerateCustomerSatisfactionReport
  //         coupon={row}
  //         buttonLabel={"SCARICA REPORT"}
  //       />
  //     );
  //   }

  //   return actions;
  // }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];

    // if (isAdminUser) {
    //   actions.push(
    //     <Button
    //       variant="contained"
    //       color="primary"
    //       onClick={() => addNewCustomerSatisfaction()}
    //     >
    //       Aggiungi Nuovo
    //     </Button>
    //   );
    // }

    return actions;
  }, []);

  // const { isAdminUser } = useLoggedUserInfo();

  const tableActions = useMemo(() => {
    const columns = [
      // "",
      "Data creazione",
      "Utente",
      "Palazzo",
      "Amenity / Servizio",
      "Rating",
      "Note",
    ];

    return columns;
  }, []);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <ActionToolbar
        title={"Customer Satisfactions"}
        actions={actionToolbarActions}
      />
      <GqlTable
        ref={tableRef}
        columns={[...tableActions].map((v) => (
          <TableCell>{v}</TableCell>
        ))}
        query={QUERIES.CUSTOMER_SATISFACTIONS}
        queryVariables={{ type: "service" }}
        queryResultDataField="customerSatisfactions"
        rows={(row: CustomerSatisfaction) => (
          <>
            {/* <TableCell>{gqlTableRowActions(row)}</TableCell> */}
            <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
            <TableCell>{row.user.fullName}</TableCell>
            <TableCell>{row.building?.code ?? "-"}</TableCell>
            <TableCell>
              {row.amenityReservation &&
                [
                  row.amenityReservation.service.name,
                  row.amenityReservation.code,
                ].join(" > ")}
              {row.serviceReservation &&
                [
                  row.serviceReservation.service.name,
                  row.serviceReservation.code,
                ].join(" > ")}
            </TableCell>
            <TableCell>
              {row.closedAt && (
                <span>
                  Chiuso volontariamente il{" "}
                  {new Date(row.closedAt).toLocaleString()}
                </span>
              )}
              {row.rating}
              {!row.closedAt && !row.rating && "Da compilare"}
            </TableCell>
            <TableCell>{row.notes}</TableCell>
          </>
        )}
      />
    </Container>
  );
}

export default withRouter(CustomerSatisfactionsPage);
